webpackJsonp([2],{

/***/ "+RO9":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__("TToO");
var base_1 = __webpack_require__("2CBV");
var vue_property_decorator_1 = __webpack_require__("443i");
var NavBar_vue_1 = __webpack_require__("KSWh");
var NavBar = /** @class */ (function (_super) {
    tslib_1.__extends(NavBar, _super);
    function NavBar() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NavBar = tslib_1.__decorate([
        vue_property_decorator_1.Component({
            name: "NavBar",
            mixins: [NavBar_vue_1.default],
            components: {}
        })
    ], NavBar);
    return NavBar;
}(base_1.default));
exports.default = NavBar;


/***/ }),

/***/ "/5sW":
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__("hWmm"))(1);

/***/ }),

/***/ "/SlL":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * App
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__("TToO");
var base_1 = __webpack_require__("2CBV");
var vue_property_decorator_1 = __webpack_require__("443i");
var App_vue_1 = __webpack_require__("fdKE");
var NavBar_1 = __webpack_require__("L/ye");
var App = /** @class */ (function (_super) {
    tslib_1.__extends(App, _super);
    function App() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(App.prototype, "navBar", {
        get: function () {
            var list = ["home", "product", "about", "join", "warn"];
            var page = this.$route.name;
            return list.indexOf(page) > -1;
        },
        enumerable: true,
        configurable: true
    });
    App = tslib_1.__decorate([
        vue_property_decorator_1.Component({
            name: "App",
            mixins: [App_vue_1.default],
            components: {
                NavBar: NavBar_1.default
            }
        })
    ], App);
    return App;
}(base_1.default));
exports.default = App;


/***/ }),

/***/ "/ocq":
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__("hWmm"))(10);

/***/ }),

/***/ 0:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "0QuU":
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__("hWmm"))(11);

/***/ }),

/***/ "1YtJ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Gender;
(function (Gender) {
    Gender[Gender["Male"] = 1] = "Male";
    Gender[Gender["Female"] = 2] = "Female";
    Gender[Gender["Ohter"] = 3] = "Ohter";
})(Gender = exports.Gender || (exports.Gender = {}));


/***/ }),

/***/ "2CBV":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * 所有组件的基类
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__("TToO");
var vue_1 = __webpack_require__("/5sW");
var api_1 = __webpack_require__("rW+9");
var util_1 = __webpack_require__("rvRl");
var env_1 = __webpack_require__("QFhE");
var constants_1 = __webpack_require__("pysO");
var Base = /** @class */ (function (_super) {
    tslib_1.__extends(Base, _super);
    function Base() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        //#region datas ******************************/
        // constants
        _this.constants = constants_1.default;
        // config
        _this.config = env_1.default;
        // backend api
        _this.api = api_1.default;
        // utils
        _this.util = util_1.default;
        return _this;
        //#endregion datas ***************************/
        //#region props ******************************/
        //#endregion props ***************************/
        //#region vuex *******************************/
        //#endregion vuex ****************************/
        //#region computed ***************************/
        //#endregion computed ************************/
        //#region watchers ***************************/
        //#endregion watchers ************************/
        //#region life cycle *************************/
        //#endregion life cycle **********************/
        //#region hooks ******************************/
        //#endregion hooks ***************************/
        //#region event handler **********************/
        //#endregion event handler *******************/
        //#region methods ****************************/
        //#endregion methods *************************/
    }
    return Base;
}(vue_1.default));
exports.default = Base;


/***/ }),

/***/ "443i":
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__("hWmm"))(12);

/***/ }),

/***/ "49fU":
/***/ (function(module, exports) {

module.exports = vendor_library;

/***/ }),

/***/ "6R6/":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * api http base
 * @author Allenice
 * @since 2017-06-30 05:35:10
 */
Object.defineProperty(exports, "__esModule", { value: true });
var axios_1 = __webpack_require__("mtWM");
var stringify = __webpack_require__("CwSZ");
var host = "/";
// build http header
function buildHeader() {
    return {};
}
exports.ax = axios_1.default.create({
    baseURL: host,
    headers: buildHeader(),
    timeout: 10000,
    responseType: "json",
    transformRequest: [
        function (data) {
            if (data instanceof FormData)
                return data;
            return stringify(data);
        }
    ],
    transformResponse: [
        function (data) {
            if (data) {
                return data;
            }
            else {
                var msg = "Unknow Error";
                throw new Error(msg);
            }
        }
    ]
});
/* tslint:disable-next-line */
function processData(data) {
    if (data === void 0) { data = {}; }
    if (data instanceof FormData) {
        // data.append('token', token)
    }
    else {
        // data.token = token
    }
    return data;
}
// 处理错误
function handleError(err) {
    // 如果是手动取消的请求，不显示错误信息
    if (axios_1.default.isCancel(err)) {
        console.log(err);
    }
    else {
        console.log(err);
    }
}
// http get method
function get(url, data) {
    return exports.ax
        .get(url, {
        params: processData(data)
    })
        .then(function (res) {
        return res.data.response;
    })
        .catch(function (err) {
        handleError(err);
        throw err;
    });
}
exports.get = get;
// http post method
function post(url, data) {
    return exports.ax
        .post(url, processData(data))
        .then(function (res) {
        return res.data;
    })
        .catch(function (err) {
        handleError(err);
        throw err;
    });
}
exports.post = post;
// delete, put, patch,etc ....


/***/ }),

/***/ "6lLi":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
var icon = __webpack_require__("0QuU");
icon.register({
    logo: {
        width: 16,
        height: 16,
        viewBox: '0 0 40 14',
        data: '<path pid="0" id="Combined-Shape" class="st0" d="M4.3 0l2.4 10.7L9.1 0h4.2v14h-2.7V2.4L7.9 14H5.5L2.7 2.4V14H0V0h4.3zM40 0v2.4h-6.6v3.3H39v2.2h-5.7V14h-2.6V0H40zM19.7 0L22 10.7 24.5 0h4.2v14H26V2.4L23.3 14h-2.4L18.1 2.4V14h-2.7V0h4.3z"/>'
    }
});


/***/ }),

/***/ "9PYM":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Create an object with values equal to its key names.
 */
Object.defineProperty(exports, "__esModule", { value: true });
function default_1(obj) {
    var ret = {};
    var key;
    for (key in obj) {
        if (obj.hasOwnProperty(key)) {
            ret[key] = key;
        }
    }
    return ret;
}
exports.default = default_1;


/***/ }),

/***/ "HATg":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
__webpack_require__("6lLi");
__webpack_require__("Lsxk");


/***/ }),

/***/ "K7Dc":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * sleep for async/await
 * @export Function
 * @param {number} ms time for sleep
 * @returns Function
 */
Object.defineProperty(exports, "__esModule", { value: true });
var timerMap = {};
function default_1(ms, label) {
    return new Promise(function (resolve) {
        var timer = setTimeout(resolve, ms);
        if (label) {
            timerMap[label] = {
                timer: timer,
                resolve: resolve
            };
        }
    });
}
exports.default = default_1;
// 取消睡眠，并继续
function wakeup(label) {
    var timer = timerMap[label];
    if (timer) {
        clearTimeout(timer.timer);
        timer.resolve();
        delete timerMap[label];
    }
}
exports.wakeup = wakeup;
// 取消睡眠
function die(label) {
    var timer = timerMap[label];
    if (timer) {
        clearTimeout(timer.timer);
        delete timerMap[label];
    }
}
exports.die = die;


/***/ }),

/***/ "KSWh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7c99a4e4","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/NavBar/NavBar.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nav-bar"},[_c('router-link',{staticClass:"flex-col",attrs:{"to":"/"}},[_c('i',{staticClass:"icon icon-index"}),_vm._v("经传多赢\n  ")]),_vm._v(" "),_c('router-link',{staticClass:"flex-col",attrs:{"to":"/product"}},[_c('i',{staticClass:"icon icon-product"}),_vm._v("产品服务\n  ")]),_vm._v(" "),_c('router-link',{staticClass:"flex-col",attrs:{"to":"/about"}},[_c('i',{staticClass:"icon icon-about"}),_vm._v("关于我们\n  ")]),_vm._v(" "),_c('router-link',{staticClass:"flex-col",attrs:{"to":"/join"}},[_c('i',{staticClass:"icon icon-join"}),_vm._v("加入我们\n  ")])],1)}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("XyMi");

// CONCATENATED MODULE: ./src/components/NavBar/NavBar.vue
function injectStyle (context) {
  __webpack_require__("Leol")
}
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7c99a4e4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  __vue_script__,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var NavBar = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "L/ye":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var NavBar_1 = __webpack_require__("+RO9");
exports.default = NavBar_1.default;


/***/ }),

/***/ "Leol":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Lsxk":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
var icon = __webpack_require__("0QuU");
icon.register({
    vue: {
        width: 400,
        height: 400,
        viewBox: '0 0 400 400',
        data: '<path pid="0" d="M237.417 86.655l-30.226 52.352-30.225-52.352H76.311l130.88 226.69 130.88-226.69z" _fill="#4dba87"/><path pid="1" d="M237.417 86.655l-30.226 52.352-30.225-52.352h-48.303l78.528 136.014L285.72 86.655z" _fill="#435466"/>'
    }
});


/***/ }),

/***/ "N1kN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NYxO":
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__("hWmm"))(4);

/***/ }),

/***/ "Ocxb":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * 深度冻结一个对象
 *
 * @param {Object} obj
 * @returns
 */
function deepFreeze(obj) {
    var propNames = Object.getOwnPropertyNames(obj);
    propNames.forEach(function (name) {
        var prop = obj[name];
        if (typeof prop === 'object' && prop !== null) {
            deepFreeze(prop);
        }
    });
    return Object.freeze(obj);
}
exports.default = deepFreeze;


/***/ }),

/***/ "QFhE":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var dev_1 = __webpack_require__("Wt5F");
dev_1.default.env = 'deploy';
exports.default = dev_1.default;


/***/ }),

/***/ "TToO":
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__("49fU"))(6);

/***/ }),

/***/ "VYSC":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * vuex store
 */
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = __webpack_require__("/5sW");
var vuex_1 = __webpack_require__("NYxO");
var vuexUtil_1 = __webpack_require__("WtS9");
var keymirror_1 = __webpack_require__("9PYM");
// import modules
vue_1.default.use(vuex_1.default);
var state = {};
var mutations = vuexUtil_1.mutation(state, {});
var store = new vuex_1.default.Store({
    strict: "production" !== 'production',
    state: state,
    mutations: mutations,
    getters: {},
    actions: {},
    modules: {}
});
exports.types = {
    state: keymirror_1.default(state),
    mutations: keymirror_1.default(mutations)
};
exports.default = store;


/***/ }),

/***/ "W2nU":
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__("hWmm"))(3);

/***/ }),

/***/ "Wt5F":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
// dev config
exports.default = {
    env: 'dev',
    version: "1.0.0"
};


/***/ }),

/***/ "WtS9":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * vuex util
 */
Object.defineProperty(exports, "__esModule", { value: true });
function getter(state, getters) {
    return getters;
}
exports.getter = getter;
function mutation(state, mutations) {
    return mutations;
}
exports.mutation = mutation;
function action(state, actions) {
    return actions;
}
exports.action = action;
function decorator(helper, keyMap) {
    function decoratorWrapper(a, b) {
        if (typeof b === 'string') {
            var target = a;
            var key = b;
            return helper(target, key);
        }
        var originKey = a;
        return helper(originKey);
    }
    return decoratorWrapper;
}
exports.decorator = decorator;


/***/ }),

/***/ "d8/S":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "fdKE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a6a63c6e","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/App/App.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app",attrs:{"id":"app"}},[_c('div',{staticClass:"view"},[_c('keep-alive',{attrs:{"include":"Join"}},[_c('router-view')],1)],1),_vm._v(" "),_c('nav-bar',{directives:[{name:"show",rawName:"v-show",value:(_vm.navBar),expression:"navBar"}]})],1)}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("XyMi");

// CONCATENATED MODULE: ./src/pages/App/App.vue
function injectStyle (context) {
  __webpack_require__("jOua")
}
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-a6a63c6e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  __vue_script__,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var App = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "hWmm":
/***/ (function(module, exports) {

module.exports = vue_library;

/***/ }),

/***/ "jOua":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "kdNR":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = __webpack_require__("/5sW");
var vue_router_1 = __webpack_require__("/ocq");
// routes
var home_1 = __webpack_require__("q66q");
/** auto import */
vue_1.default.use(vue_router_1.default);
// prettier-ignore
var routes = []
    .concat(home_1.default)
    /** auto concat */
    .concat([]);
exports.default = new vue_router_1.default({
    routes: routes
});


/***/ }),

/***/ "pysO":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var enum_1 = __webpack_require__("1YtJ");
var util_1 = __webpack_require__("rvRl");
var constants = {
    Gender: enum_1.Gender
};
util_1.default.deepFreeze(constants);
exports.default = constants;


/***/ }),

/***/ "q66q":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * home module router
 */
Object.defineProperty(exports, "__esModule", { value: true });
function getView(viewName) {
    return function (resolve, reject) {
        __webpack_require__.e/* require.ensure */(0).then((function (require) {
            var map = {
                home: __webpack_require__("MX7K"),
                detail: __webpack_require__("8q2w"),
                product: __webpack_require__("LjpI"),
                about: __webpack_require__("bwX4"),
                warn: __webpack_require__("41qT"),
                feedback: __webpack_require__("lGol"),
                join: __webpack_require__("+85R"),
                recruit: __webpack_require__("KzAL"),
                jobDetails: __webpack_require__("jvYm"),
                resumes: __webpack_require__("50x+") // 简历投递
            };
            resolve(map[viewName]);
        }).bind(null, __webpack_require__)).catch(reject);
    };
}
var routes = [
    {
        name: "home",
        path: "/"
    },
    {
        name: "detail",
        path: "/detail"
    },
    {
        name: "product",
        path: "/product"
    },
    {
        name: "about",
        path: "/about"
    },
    {
        name: "warn",
        path: "/about/warn"
    },
    {
        name: "feedback",
        path: "/feedback"
    },
    {
        name: "join",
        path: "/join"
    },
    {
        name: "recruit",
        path: "/recruit"
    },
    {
        name: "jobDetails",
        path: "/jobDetails"
    },
    {
        name: "resumes",
        path: "/resumes"
    },
    {
        name: "defaultView",
        path: "*"
    }
];
routes.forEach(function (v) {
    if (!v.redirect && !v.component) {
        v.component = getView(v.name);
    }
});
exports.default = routes;


/***/ }),

/***/ "rW+9":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var axios_1 = __webpack_require__("mtWM");
var http_1 = __webpack_require__("6R6/");
exports.default = {
    // 获取轮播列表
    getBanner: function (params) {
        if (params === void 0) { params = {}; }
        return http_1.get("https://gw.n8n8.cn/uportrait/api/v1/pd/list", params);
    },
    // 获取投顾列表
    getCustomer: function (top, limit, page) {
        if (top === void 0) { top = 1; }
        if (limit === void 0) { limit = 100; }
        if (page === void 0) { page = 1; }
        return http_1.get("https://gw.n8n8.cn/n8sf/app/jz/v1/adviser/lists", {
            top: top,
            limit: limit,
            page: page
        });
    },
    // 获取动态列表
    getArticle: function (limit, page) {
        if (limit === void 0) { limit = 10; }
        if (page === void 0) { page = 1; }
        return http_1.get("https://gw.n8n8.cn/n8sf/app/jz/v1/article/lists", {
            category: 1,
            limit: limit,
            page: page
        });
    },
    // 获取文章详情
    getContent: function (id) {
        return http_1.get("https://gw.n8n8.cn/n8sf/app/jz/v1/article/detail", {
            id: id
        });
    },
    // 提交反馈
    submitFeedback: function (name, mobile, message) {
        return http_1.post("https://gw.n8n8.cn/n8sf/app/jz/v1/message/send", {
            type: 1,
            name: name,
            mobile: mobile,
            message: message
        });
    },
    // 获取部门列表（含岗位数量）
    getDepartment: function (page, limit, position_type) {
        if (page === void 0) { page = 1; }
        if (limit === void 0) { limit = 1; }
        return http_1.get("https://gw.n8n8.cn/www/api/v1/recruit/department/list", {
            page: page,
            limit: limit,
            is_valid: 1,
            position_type: position_type
        });
    },
    // 获取取职位列表
    getPosition: function (page, limit, type, department_id, name) {
        if (page === void 0) { page = 1; }
        if (limit === void 0) { limit = 50; }
        return http_1.get("https://gw.n8n8.cn/www/api/v1/recruit/position/list", {
            page: page,
            limit: limit,
            type: type,
            department_id: department_id,
            name: name
        });
    },
    // 职位详情
    getJobDetails: function (id) {
        return http_1.get("https://gw.n8n8.cn/www/api/v1/recruit/position/detail", {
            id: id
        });
    },
    // 获取部门列表（全部）
    getAllDepartment: function () {
        return http_1.get("https://gw.n8n8.cn/www/api/v1/recruit/department/option-list", {
            is_valid: 1
        });
    },
    // 获取小程序短链接
    getGenerateUrlLink: function (query) {
        return http_1.post("https://gw.n8n8.cn/wechat/api/v2/minp/serve/generate-url-link", {
            name: "duanxianwang",
            page: "/pages/preview1/index",
            query: "code=" + query,
            out_date_num: 1
        });
    },
    // 文件上传-获取七牛密钥
    getUploadToken: function (key) {
        return http_1.get("https://gw.n8n8.cn/n8sf/app/v1/qiniu/token", {
            key: key
        });
    },
    // 文件上传-上传七牛文件
    postUploadFile: function (data) {
        return http_1.ax.post("https://upload.qiniup.com", data, {
            headers: {
                "Content-Type": "multipart/form-data"
            }
        });
    },
    // 简历投递
    getDeliver: function (name, phone, position_id, resume_file) {
        return http_1.post("https://gw.n8n8.cn/www/api/v1/recruit/resume/deliver", {
            name: name,
            phone: phone,
            position_id: position_id,
            resume_file: resume_file
        });
    },
    ax: http_1.ax,
    axios: axios_1.default
};


/***/ }),

/***/ "rvRl":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * util
 */
Object.defineProperty(exports, "__esModule", { value: true });
var sleep_1 = __webpack_require__("K7Dc");
var deepFreeze_1 = __webpack_require__("Ocxb");
exports.default = {
    sleep: sleep_1.default,
    deepFreeze: deepFreeze_1.default,
    // Window userAgent
    UA: function () {
        return window.navigator.userAgent;
    },
    // Checks if in the APP
    isAPP: function () {
        return /n8Web/i.test(this.UA());
    },
    // Checks if in the uni-app web-view
    isUniWebView: function () {
        return /jzUni/i.test(this.UA());
    },
    // Checks if in the wx web-view
    isWxWebView: function () {
        return /miniProgram/i.test(this.UA());
    },
    // Checks if in the IOS
    isIOS: function () {
        return /iphone|ipad|ipod/i.test(this.UA());
    },
    // Checks if in the Android
    isAndroid: function () {
        return /android/i.test(this.UA());
    },
    // Checks if in the Weixin
    isWeixin: function () {
        return /MicroMessenger/i.test(this.UA());
    },
    // IOS handlers
    runIOS: function (data, fallback, method) {
        if (fallback === void 0) { fallback = function () { }; }
        if (method === void 0) { method = "N8WebView"; }
        if (!this.isIOS())
            return false;
        var webkit = window.webkit;
        var handler = webkit && webkit.messageHandlers[method];
        if (!handler)
            return fallback();
        return handler.postMessage(data);
    },
    // Android handlers
    runAndroid: function (data, method, callback, fallback) {
        if (method === void 0) { method = ""; }
        if (callback === void 0) { callback = ""; }
        if (fallback === void 0) { fallback = function () { }; }
        if (!this.isAndroid())
            return false;
        var android = window.android;
        if (!android)
            return fallback();
        return android[method](JSON.stringify(data), callback);
    }
};


/***/ }),

/***/ "ubJl":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * App
 */
Object.defineProperty(exports, "__esModule", { value: true });
var App_1 = __webpack_require__("/SlL");
exports.default = App_1.default;


/***/ }),

/***/ "v2ns":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "wDGr":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * register plugins hooks for vue component
 */
Object.defineProperty(exports, "__esModule", { value: true });
var vue_property_decorator_1 = __webpack_require__("443i");
vue_property_decorator_1.Component.registerHooks(['beforeRouteEnter', 'beforeRouteLeave']);


/***/ }),

/***/ "x35b":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = __webpack_require__("/5sW");
// register plugins hooks fo vue component
__webpack_require__("wDGr");
var svgicon = __webpack_require__("0QuU");
// import all icons
__webpack_require__("HATg");
var router_1 = __webpack_require__("kdNR");
var store_1 = __webpack_require__("VYSC");
var App_1 = __webpack_require__("ubJl");
__webpack_require__("d8/S");
var mint_ui_1 = __webpack_require__("Au9i");
vue_1.default.component(mint_ui_1.Swipe.name, mint_ui_1.Swipe);
vue_1.default.component(mint_ui_1.SwipeItem.name, mint_ui_1.SwipeItem);
var v_viewer_1 = __webpack_require__("EAZf");
__webpack_require__("N1kN");
vue_1.default.use(v_viewer_1.default);
var vue_awesome_swiper_1 = __webpack_require__("7QTg");
__webpack_require__("v2ns");
vue_1.default.use(vue_awesome_swiper_1.default);
vue_1.default.use(svgicon, {
    tagName: "icon"
});
new vue_1.default({
    el: "#app",
    router: router_1.default,
    store: store_1.default,
    render: function (h) { return h(App_1.default); }
});


/***/ })

},["x35b"]);


// WEBPACK FOOTER //
// static/js/app.60231670def5591a38c5.js